import logo from "../../Images/logo.png"

export default function Logo(props) {
	const wrapperClassName = props.className ?? "text-center text-md-left px-md-5 mx-5";

	return 	<div className={wrapperClassName}>
				<img style={{ width: "300px"}} src={ logo } onClick={props.onClick}></img>
			</div>
}